/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { datapointByProfileByYearByCodeByDatapointIdGet } from '../fn/esg-disclosure-datapoint/datapoint-by-profile-by-year-by-code-by-datapoint-id-get';
import { DatapointByProfileByYearByCodeByDatapointIdGet$Params } from '../fn/esg-disclosure-datapoint/datapoint-by-profile-by-year-by-code-by-datapoint-id-get';
import { EsgDisclosureDatapoint } from '../models/esg-disclosure-datapoint';

@Injectable({ providedIn: 'root' })
export class EsgDisclosureDatapointService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `datapointByProfileByYearByCodeByDatapointIdGet()` */
  static readonly DatapointByProfileByYearByCodeByDatapointIdGetPath = '/esg/profile/{profileId}/{year}/{code}/{dataPointId}';

  /**
   * Get datapoint for profile.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `datapointByProfileByYearByCodeByDatapointIdGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  datapointByProfileByYearByCodeByDatapointIdGet$Response(params: DatapointByProfileByYearByCodeByDatapointIdGet$Params, context?: HttpContext): Observable<StrictHttpResponse<EsgDisclosureDatapoint>> {
    return datapointByProfileByYearByCodeByDatapointIdGet(this.http, this.rootUrl, params, context);
  }

  /**
   * Get datapoint for profile.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `datapointByProfileByYearByCodeByDatapointIdGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  datapointByProfileByYearByCodeByDatapointIdGet(params: DatapointByProfileByYearByCodeByDatapointIdGet$Params, context?: HttpContext): Observable<EsgDisclosureDatapoint> {
    return this.datapointByProfileByYearByCodeByDatapointIdGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<EsgDisclosureDatapoint>): EsgDisclosureDatapoint => r.body)
    );
  }

}
